// extracted by mini-css-extract-plugin
export default {"option-refetch-button":"xbeRzhUaw_dwV09_UCDQ"};